<template>
  <Head title="Login" />
  <div class="login-wrapper">
    <div class="login-card">
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h2>Extranet Wintower</h2>
          <text-input v-model="form.email" class="flexrow" :error="form.errors.email" label="Benutzername" type="text" autofocus autocapitalize="off" />
          <text-input v-model="form.password" class="flexrow" :error="form.errors.password" label="Passwort" type="password" />
          <div class="remember">
            <div class="spacer">&nbsp;</div>
            <label for="remember" ><input id="remember" v-model="form.remember" class="mr-1" type="checkbox" /> &nbsp;Remember Me</label>
          </div>
        </div>
        <div class="calltoaction">
          <div class="spacer">&nbsp;</div>
          <loading-button :loading="form.processing"  type="submit">Login</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { Head } from '@inertiajs/inertia-vue3'
  import Logo from '@/Shared/Logo'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'

  export default {
    components: {
      Head,
      LoadingButton,
      Logo,
      TextInput,
    },
    data() {
      return {
        form: this.$inertia.form({
          email: '',
          password: '',
          remember: false,
        }),
      }
    },
    methods: {
      login() {
        this.form.post('/login')
      },
    },
  }
</script>
